import { z } from 'zod'
import { AuftragX_95Schema } from '../../Auftraege'
import {
  KmhSchema,
  KmSchema,
  SignalSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'

// Default constants
const DEFAULT_AUFTRAG_5_41 = {
  enabled: true,
  feld_5_42_1_kmh: '',
  selector: '' as const,
  feld_5_43_zugmeldestelle: {
    art: '' as const,
    name: ''
  },
  feld_5_44_zugmeldestelle: {
    art: '' as const,
    name: ''
  },
  feld_5_47_type: '' as const,
  feld_5_47_1_km: '',
  feld_5_47_2_signal: '',
  feld_5_48_type: '' as const,
  feld_5_48_1_km: '',
  feld_5_48_2_signal: ''
}

const DEFAULT_BEFEHL_5_FORM = {
  auftrag_5_41: DEFAULT_AUFTRAG_5_41,
  auftrag_5_95: {
    enabled: false,
    freitext: ''
  }
}

// Schema definitions
const Auftrag5_41Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_5_41.enabled),
    feld_5_42_1_kmh: KmhSchema,
    selector: z
      .enum(['', 'in', 'zwischen'])
      .default(DEFAULT_AUFTRAG_5_41.selector),
    feld_5_43_zugmeldestelle: ZugmeldestelleSchema,
    feld_5_44_zugmeldestelle: ZugmeldestelleSchema,
    feld_5_47_type: z
      .enum(['', 'km', 'signal'])
      .default(DEFAULT_AUFTRAG_5_41.feld_5_47_type),
    feld_5_47_1_km: KmSchema,
    feld_5_47_2_signal: SignalSchema,
    feld_5_48_type: z
      .enum(['', 'km', 'signal'])
      .default(DEFAULT_AUFTRAG_5_41.feld_5_48_type),
    feld_5_48_1_km: KmSchema,
    feld_5_48_2_signal: SignalSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_5_41))

// Base schema
const Befehl5FormSchemaBase = z
  .object({
    // Auftrag 5.41
    auftrag_5_41: Auftrag5_41Schema,

    // Auftrag 5.95
    auftrag_5_95: AuftragX_95Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_5_FORM))

export const Befehl5FormSchema = Befehl5FormSchemaBase

// Validation schema factory
export const createBefehl5FormValidationSchema = () => {
  return Befehl5FormSchemaBase
}

export type Befehl5FormData = z.infer<typeof Befehl5FormSchemaBase>
